import React from "react";

const NotFoundPage = () => {
  return <div>ERROR 404 Page not found</div>;
};

export default NotFoundPage;
